const zhTW = {
  'banner.introduction': '提供企業即時、互動的視覺化人才發展整合方案',
  'banner.introduction.covid':
    'AMPOS與您攜手共度難關！ 從2020年四月到2020年六月， AMPOS將提供免費防疫服務方案。',
  'banner.introduction.post-covid':
    '後疫情時代，Ampos 免費提供平台功能，協助台灣企業在後疫情時代，能更有效的與員工溝通，並進行遠端管理',
  'featureList.onboarding': '員工入職計畫',
  'featureList.onboarding.content':
    '階段性的入職流程，讓新人快速有條理地熟悉公司與基本的作業、流程等。',
  'featureList.structuredTraining': '結構化的培訓',
  'featureList.structuredTraining.content':
    '整合的線上、線下培訓資源，通過權限控管，讓員工方便聚焦在職務能力的提升並打造符合員工需求的學習旅程。',
  'featureList.behaviorRecongnition': '員工激勵',
  'featureList.behaviorRecongnition.content':
    '以遊戲化的方式，達成即時、頻繁的多維度正向回饋，營造企業內部正向循環的氛圍。幫助高階管理者更及時掌握組織行為和團隊表現。',
  'featureList.personalDevelopment': '個人化的發展',
  'featureList.personalDevelopment.content':
    'Coaching、個人發展計畫為潛力員工量身訂製；可根據追蹤個人指標的弱項，提升相對的能力。',
  'featureList.organizationalCommunication': '組織溝通',
  'featureList.organizationalCommunication.content':
    '便於追蹤的公告讀取、員工回饋、調研、以及以部門為單位的聊天群，雙向的管道提升組織溝通成效。',
  'featureList.realtimePerformanceTracking': '實時績效追蹤',
  'featureList.realtimePerformanceTracking.content':
    '即時、量化的指標追蹤，部屬日常表現不漏接；搭配個人化的發展/結構化的培訓，讓評鑒與考核不再只有開始與結束。',
  'featureList.companySuccessionPlanning': '企業接班人計劃',
  'featureList.companySuccessionPlanning.content':
    '通過長期追蹤員工的各項表現進行分類與搜尋，成為企業補齊職位空缺的有效工具。',
  copyRight: 'Copyright @ 2020 AMPOS Solutions Inc. All Rights Reserved',
  'product.title': '產品',
  'product.introduction':
    '因應企業外在環境的快速變化與突發挑戰，AMPOS以整合性的人才管理為出發點，建構一套能夠即時反應員工狀態，讓同儕與主管在第一時間給予激勵與協助的整合方案，以提升人才管理的即時性與有效性。',
  'product.download': '請點擊下載按鈕來安裝應用程序',
  'product.store.ios': 'App Store',
  'product.store.google': 'Google Play',
  'product.store.360': '360手機助手',
  'product.store.tencent': '騰訊應用寶',
  'product.store.baidu': '百度手機助手',
  'product.store.huawei': '華為應用市場',
  'product.store.oppo': 'OPPO軟件商店',
  'product.store.xiaomi': '小米應用商店',
  'product.store.flyme': 'Flyme開放平台',
  'product.store.wandoujia': '豌豆莢',
  'service.intro.title': '服務',
  'service.intro.subtitle': '顧問諮詢與大型專案服務',
  'service.intro.content1': `AMPOS的跨國團隊擁有豐富的經驗，可以為世界級大型公司提供基於Amazon Web Services（AWS）的基於雲端企業軟體解決方案。 我們從全球領先的技術公司招募了經驗豐富的產品經理，工程師和解決方案交付專家。
   \nAMPOS團隊在SaaS企業軟體開發和AWS服務方面具備深厚專業知識的公司，並提供顧問諮詢和專案的服務。
   \n聆聽我們的首席技術官兼首席架構師，了解我們如何在AWS全球和中國地區管理我們的解決方案架構。`,
  'service.intro.content2':
    "We recruited experienced product managers, engineers, and solution delivery experts from leading global technology companies.AMPOS provides consulting and project based services to companies in need of leveraging AMPOS team's deep expertise in SaaS enterprise software development and AWS services.",
  'service.intro.content3':
    '亞馬遜雲平台曾針對我們的使用案例專訪過我們的CTO和Chief Architect',
  'service.content.title': '諮詢和專案項目:',
  'service.content.list1': '雲端數據管理和架構諮詢',
  'service.content.list2': '企業級軟件開發',
  'service.content.list3': ' ',
  'service.content.content':
    '我們的團隊專長包括：Agile/Scrum Project management, Software architect, Business Analyse, UX/UI Design, Kotlin, Java, iOS, NodeJS, Python, Android, Angular, AWS, ReactJS, Flutter。　我們也是亞馬遜雲平台的諮詢合作夥伴，並具有以下亞馬遜雲平台服務的深度了解和實際並具有以下亞馬遜雲平台服務的深度了解和實際實施經驗：AWS ElastiCache, SNS, SQS, CloudFront, Lambda, ELB, EC2, ECS, Elastic Beanstalk, DynamoDB, RDS, S3, CloudFormation, Route53。',
  'contact.taipeiCompanyName': '易智能股份有限公司台灣分公司',
  'contact.taipeiAddress': '台北市大安區仁愛路三段141號6樓',
  'contact.chinaCompanyName': 'AMPOS – 中國',
  'contact.chinaAddress': '上海市静安區泰興路89號4F',
  'contact.bangkokCompanyName': 'AMPOS – 曼谷',
  'contact.bangkokAddress':
    '699 Modernform Tower, 22nd Floor, Unit No. 2204 Srinakarindr Road, Phatthanakan,  Suanluang,  Bangkok  10250',
  'contact.phone': '電話. ',
  'contact.form.title': '聯絡我們',
  'contact.form.name': '姓名',
  'contact.form.email': '電子郵件',
  'contact.form.phone': '電話',
  'contact.form.comment': '內容',
  'contact.form.submit': '送出',
  'contact.form.validation.required': 'Required',
  'contact.form.validation.invalid.email': 'Invalid email address',
  'contact.form.validation.invalid.phone': 'Phone number is not valid',
  'about.header': '關於我們',
  'about.main.content':
    '致力於研發協助HR夥伴推動人才發展的各種工具、發揮人才最大價值的企業多元方案。想要節省營運成本、提高營運績效、培育及發掘內部人才、精准管理到各階層人員？我們都能做到，且超乎想像。面臨無從改變的窘況？我們的專業顧問群將會提供您一套量身訂做而專業的解決方案。\n目前已成功協助製造、餐飲、零售等相關產業提升人力資源運用，並於上海、臺北、曼谷成立據點，深耕國際市場，打造世界級的研發環境。',
  'about.team.title': '我們的團隊',
  'about.team.introduction':
    '我們是一個成長快速的新創公司，網羅網際網路相關領域的專業人員，他們曾任職於 Amazon，IBM，MicroStrategy，PayPal，PwC，Thomson Reuters，Trend Micro 等大型科技公司，且從哈佛商學院，卡內基梅隆大學畢業。團隊間擁有極佳默契，經常腦力激蕩發揮潛力以創造創新價值，專注於探究市場與產業的需求，用心聆聽客戶的需求去擬定企業解決方案及專案規劃，創造企業的核心價值，因為我們相信客戶的成功就是我們最大的成功。',
  'about.press.header': 'AMPOS in the Press',
  'career.header.title': 'Career',
  'career.benefit.title': 'BENEFIT',
  'career.benefit.list1':
    'Performance-based bonus every 6 months (i.e. twice per year)',
  'career.benefit.list2': 'Flexible working hours',
  'career.benefit.list3':
    'Ten (10) paid vacation days, with a 2-day increment each year, up to a maximum of 20 days total',
  'career.benefit.list4': 'Free drinks and snacks',
  'career.benefit.list5': 'Free team polo shirts in different colors',
  'career.benefit.list6':
    'Relaxed working environment (e.g. Xbox 360, PS3, and ping pong table)',
  'career.benefit.list7': 'Team outings and teamwork activities',
  'career.benefit.list8': 'Developer, IT, creative/design training program',
  'career.benefit.list9':
    'Opportunity to work in foreign countries (some positions only)',
  'career.benefit.list10':
    'Opportunity to participate in offline marketing events with compensation of 2,000 THB per day',
  'career.benefit.list11':
    'Employee referral program of 20,000 THB per successful referral, for both Introducer and referrals',
  'career.benefit.list12': 'Group health insurance and social security',
  'header.home': '主頁',
  'header.product': '產品',
  'header.solution': '方案',
  'header.service': '服務',
  'header.about': '關於我們',
  'header.career': '徵才',
  'header.contact': '聯絡我們',
  'header.language': '語言',
  'header.download': '下載',
  'email.successMsg': '我們已收到您的需求，將儘快與您回覆',
  'email.errorMsg': '目前服務出了問題，請稍後再試',
  faq: '幫助中心',
};
export default zhTW;
